import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/lib/legalContent";

export default function LegalPage({ doc }) {
  const { t, i18n } = useTranslation();
  const lng = (i18n.language || "ro").slice(0, 2);
  const sections = (LEGAL[lng] || LEGAL.ro)[doc] || [];
  const title = doc === "terms" ? t("legal.termsTitle") : doc === "refund" ? t("legal.refundTitle") : t("legal.privacyTitle");

  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={`legal-${doc}`}>
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-orange-600 transition-colors mb-6">
        <ArrowLeft className="w-4 h-4" /> {t("nav.home")}
      </Link>
      <h1 className="text-4xl font-black tracking-tight text-slate-900">{title}</h1>
      <p className="text-sm text-slate-400 mt-2 mb-10">{t("legal.lastUpdated")}</p>
      <div className="space-y-8">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="text-lg font-bold text-slate-900">{s.h}</h2>
            <p className="text-slate-600 leading-relaxed mt-2">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
